"use strict";
var _a, _b, _c, _d, _e;
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalizationRegulatoryFieldsCountryMap = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const localization_company_regulatory_field_entity_1 = require("./localization-company-regulatory-field.entity");
const localization_country_entity_1 = require("./localization-country.entity");
let LocalizationRegulatoryFieldsCountryMap = class LocalizationRegulatoryFieldsCountryMap {
};
exports.LocalizationRegulatoryFieldsCountryMap = LocalizationRegulatoryFieldsCountryMap;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)({ name: 'id' }),
    tslib_1.__metadata("design:type", Number)
], LocalizationRegulatoryFieldsCountryMap.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: 'country_id' }),
    tslib_1.__metadata("design:type", Number)
], LocalizationRegulatoryFieldsCountryMap.prototype, "countryId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: 'regulatory_key_id' }),
    tslib_1.__metadata("design:type", Number)
], LocalizationRegulatoryFieldsCountryMap.prototype, "regulatoryKeyId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: 'field_label', type: 'varchar' }),
    tslib_1.__metadata("design:type", String)
], LocalizationRegulatoryFieldsCountryMap.prototype, "fieldLabel", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({
        name: 'created_at',
        type: 'timestamptz',
        default: () => 'CURRENT_TIMESTAMP',
    }),
    tslib_1.__metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], LocalizationRegulatoryFieldsCountryMap.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)({
        name: 'updated_at',
        type: 'timestamptz',
        default: () => 'CURRENT_TIMESTAMP',
    }),
    tslib_1.__metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], LocalizationRegulatoryFieldsCountryMap.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: 'meta_data', type: 'jsonb', nullable: true }),
    tslib_1.__metadata("design:type", typeof (_c = typeof Record !== "undefined" && Record) === "function" ? _c : Object)
], LocalizationRegulatoryFieldsCountryMap.prototype, "metaData", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => localization_country_entity_1.LocalizationCountry, { eager: false }),
    (0, typeorm_1.JoinColumn)({ name: 'country_id' }),
    tslib_1.__metadata("design:type", typeof (_d = typeof localization_country_entity_1.LocalizationCountry !== "undefined" && localization_country_entity_1.LocalizationCountry) === "function" ? _d : Object)
], LocalizationRegulatoryFieldsCountryMap.prototype, "country", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => localization_company_regulatory_field_entity_1.LocalizationCompanyRegulatoryFields, { eager: false }),
    (0, typeorm_1.JoinColumn)({ name: 'regulatory_key_id' }),
    tslib_1.__metadata("design:type", typeof (_e = typeof localization_company_regulatory_field_entity_1.LocalizationCompanyRegulatoryFields !== "undefined" && localization_company_regulatory_field_entity_1.LocalizationCompanyRegulatoryFields) === "function" ? _e : Object)
], LocalizationRegulatoryFieldsCountryMap.prototype, "regulatoryField", void 0);
exports.LocalizationRegulatoryFieldsCountryMap = LocalizationRegulatoryFieldsCountryMap = tslib_1.__decorate([
    (0, typeorm_1.Entity)('localization_regulatory_fields_country_map')
], LocalizationRegulatoryFieldsCountryMap);
